import { mergeClassNames } from '@base-ui/react/merge-props';
import { ReactNode } from 'react';

import { mergeClasses } from '@/utils';

import { ChevronRightIcon } from '@/assets/icons';

export interface IItemContent {
  children: ReactNode;
  variant?: 'arrow' | 'border';
  onClick?: () => void;
  isSelected: boolean;
  className?: string;
}

export const ItemContent = ({
  children,
  variant = 'arrow',
  onClick,
  isSelected = false,
  className,
}: IItemContent) => {
  return (
    <button
      className={mergeClasses(
        'flex flex-row justify-between items-center p-6 min-w-[284px] hover:bg-neutral-3 bg-neutral-0',
        isSelected && 'bg-primary-lightest',
        variant === 'border' &&
          isSelected &&
          'border-[2px] border-transparent border-r-primary-base',
        className,
      )}
      onClick={onClick}
    >
      {children}
      {variant === 'arrow' && (
        <ChevronRightIcon
          className={mergeClassNames('size-6', isSelected ? 'text-primary-base' : 'text-neutral-9')}
        />
      )}
    </button>
  );
};
